import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { stickyActionBar } from "./StickyActionBar.variants.js";
import { Button } from "../Button/index.js";
import { A } from "../A/index.js";
function StickyActionBar({ children, headerContent, actionText, helperText, isLink = false, url, type = 'primary', onClick, ...variantProps }) {
    const { root, mainContainer, textContainer, actionContainer, headerContainer, helperTextSlot } = stickyActionBar(variantProps);
    return /*#__PURE__*/ jsxs("div", {
        className: root(),
        children: [
            headerContent && /*#__PURE__*/ jsx("div", {
                className: headerContainer(),
                children: headerContent
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "px-4 pb-2 pt-4",
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: mainContainer(),
                        children: [
                            /*#__PURE__*/ jsx("div", {
                                className: textContainer(),
                                children: children
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: actionContainer(),
                                children: isLink ? /*#__PURE__*/ jsx(A, {
                                    href: url,
                                    type: type ?? 'primaryShop',
                                    className: "w-full",
                                    size: "lg",
                                    shadow: true,
                                    children: actionText
                                }) : /*#__PURE__*/ jsx(Button, {
                                    type: type ?? 'primary',
                                    className: "w-full",
                                    size: "lg",
                                    shadow: true,
                                    onClick: onClick,
                                    children: actionText
                                })
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ jsx("div", {
                        className: helperTextSlot(),
                        children: helperText
                    })
                ]
            })
        ]
    });
}
export { StickyActionBar };
